import { useCallback } from "react";
import { TextCell } from "./TextCell";
import { formatCents, parseCents } from "nate-react-api-helpers";
import { jsx as _jsx } from "react/jsx-runtime";
export function MoneyCell(props) { var _onChange = props.onChange; var onChange = useCallback(function (value, extra) { try {
    _onChange(parseCents(value), extra);
}
catch (e) {
    _onChange(0, extra);
} }, [_onChange]); return /*#__PURE__*/ _jsx(TextCell, { value: formatCents(props.value), align: "right", onCancel: props.onCancel, onChange: onChange }); }
